import React from 'react';
import { useTranslation } from 'next-i18next';
import { useGetQuizUserInfo } from '@/api';
import { EnterTracking } from '@/components/EnterTracking';
import { useUserQuizes } from '@/module/profile/user/hooks/useFetchUserQuizes';
import { UserQuizList } from '@/module/profile/user/UserQuizList';
import { ListLayoutContainer, ListLayoutWrapper } from '@/shared/quizList/Layout';
import { SearchInputQuizForm } from '@/shared/quizList/SearchField';
import { type QuizListSearchProps, SearchMetaBar } from '@/shared/quizList/SearchField/SearchMetaBar';
import { UserProfile } from '../share/UserProfile/UserProfile';
export const UserProfilePage = ({
  userHashId
}: {
  userHashId: string;
}) => {
  const {
    data
  } = useGetQuizUserInfo(userHashId);
  const {
    t
  } = useTranslation(['common']);
  const {
    totalCount
  } = useUserQuizes(userHashId);
  // 하이드레이션되기에 발생하지않는다
  if (!data?.data) return null;
  return <EnterTracking eventName={'enter_user_profile'} eventProperties={{
    userEmail: data.data.userEmail,
    username: data.data.username
  }} data-sentry-element="EnterTracking" data-sentry-component="UserProfilePage" data-sentry-source-file="UserProfilePage.tsx">
      <ListLayoutWrapper className={'pt-lg'} data-sentry-element="ListLayoutWrapper" data-sentry-source-file="UserProfilePage.tsx">
        <ListLayoutContainer className={'max-w-[1840px] gap-none max-tablet-sm:gap-none'} data-sentry-element="ListLayoutContainer" data-sentry-source-file="UserProfilePage.tsx">
          <div className={'flex w-full flex-col gap-md'}>
            <UserProfile email={null} isAmbassador={data.data.isAmbassador} userHashId={userHashId} name={data?.data.username} avatarData={data.data.avatarData} data-sentry-element="UserProfile" data-sentry-source-file="UserProfilePage.tsx" />
            <SearchField eventType={'user'} totalCount={t('common:formatNumber.count', {
            n: totalCount.toLocaleString()
          })} data-sentry-element="SearchField" data-sentry-source-file="UserProfilePage.tsx" />
          </div>
          <div className={'w-full'}>
            <UserQuizList userHashId={userHashId} userEmail={data.data.userEmail} username={data.data.username} countryCode={data?.data.countryCode ?? 'EN'} data-sentry-element="UserQuizList" data-sentry-source-file="UserProfilePage.tsx" />
          </div>
        </ListLayoutContainer>
      </ListLayoutWrapper>
    </EnterTracking>;
};
const SearchField = (props: QuizListSearchProps) => {
  const {
    t
  } = useTranslation(['common']);
  return <div className={'flex items-center justify-between gap-xs pb-xs'} data-sentry-component="SearchField" data-sentry-source-file="UserProfilePage.tsx">
      <SearchInputQuizForm {...props} placeholder={t('public.search.placeholder')} data-sentry-element="SearchInputQuizForm" data-sentry-source-file="UserProfilePage.tsx" />
      <SearchMetaBar {...props} data-sentry-element="SearchMetaBar" data-sentry-source-file="UserProfilePage.tsx" />
    </div>;
};